import { render } from "./PlanPago.vue?vue&type=template&id=68b4f197&scoped=true"
import script from "./PlanPago.vue?vue&type=script&lang=js"
export * from "./PlanPago.vue?vue&type=script&lang=js"

import "./PlanPago.vue?vue&type=style&index=0&id=68b4f197&scoped=true&lang=css"
import "./PlanPago.vue?vue&type=style&index=1&id=68b4f197&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b4f197"]])

export default __exports__